// src/axiosConfig.js
import axios from 'axios';

// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const getToken = () => {
  return localStorage.getItem("accessToken")
};

// Request Interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Retrieve the token from local storage
    const token = localStorage.getItem('accessToken');
    if (token) {
      // Attach the token to the Authorization header
      config.headers = {
        ...config.headers, 
        "Content-Type": "application/json",
        "X-API-KEY": process.env.NEXT_PUBLIC_X_API_KEY,
        Authorization: `Bearer ${getToken()}`,
      };   
     }
    return config;
  },
  (error) => {
    // Handle the error
    return Promise.reject(error);
  }
);

// Response Interceptor
apiClient.interceptors.response.use(
  (response) => {
    // Return the response data if the request is successful
    return response;
  },
  (error) => {
    // Check if the error response status is 401
    if (error.response && error.response.status === 401) {
      // Redirect the user to the login page
      localStorage.clear();
      window.location.href = '/login';
    }
    // Reject the promise with the error object
    return Promise.reject(error);
  }
);

export default apiClient;






